import { StaticImage } from "gatsby-plugin-image";
import React, { useRef, useState } from "react";
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { stripHtmlTags } from "../../utils/commonFunctions";
import CourseExpert from "./courseExpert";

import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Pagination, Navigation]);

const CourseExpertList = ({
  expertsData,
  title = "Courses crafted by experts"
}) => {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  return (
    <section
      className={`relative flex justify-center z-0
    before:z-20 before:absolute before:h-full before:w-0 before:md:w-60 before:right-0 before:md:right-0 before:top-0 before:bg-gradient-to-l before:from-gray-lighten before:planet:from-gray-dark before:planet:via-transparent
    ${
      currentSlide === expertsData.length - 1 ? "before:hidden" : "before:block"
    }`}
    >
      <div className="absolute w-full h-full bg-gray-lighten planet:bg-gray-dark overflow-hidden ">
        <StaticImage
          src={"../../images/online/pebble-ground.png"}
          className="w-full h-full planet:hidden"
          alt={""}
        />
        <StaticImage
          src={"../../images/online/meet-course-expert.png"}
          className="w-full h-full hidden planet:md:block bg-gray-light"
          alt={""}
        />
        <StaticImage
          src={"../../images/online/leaf-dew-small.png"}
          className="w-full h-full hidden planet:block planet:md:hidden relative z-0
        opacity-20 before:z-10 before:absolute before:w-full before:h-full
        before:right-0 before:top-0 before:bg-gradient-to-r
        before:from-gray-light before:to-transparent"
          alt={""}
        />
      </div>
      <div className="relative w-11/12 md:gvi-container z-10 my-12 md:my-28">
        <div
          className="h2 mb-14 text-black-lighter planet:text-white"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <div className="course-experts-swiper">
          <Swiper
            ref={swiperRef}
            grabCursor={true}
            centeredSlides={false}
            slidesPerView={1.2}
            spaceBetween={30}
            loop={false}
            className="w-[95vw] overflow-hidden sm:w-[85vw] justify-center items-center pb-14 sm:!py-2"
            onSlideChange={(swiperCore) => {
              const { activeIndex } = swiperCore;
              setCurrentSlide(activeIndex);
            }}
            breakpoints={{
              320: {
                slidesPerView: 1.2,
                spaceBetween: 30,
                navigation: true,
                centeredSlides: false
              },
              640: {
                slidesPerView: 1.5,
                spaceBetween: 53,
                navigation: true,
                centeredSlides: false
              }
            }}
          >
            {expertsData?.map((expert, index) => {
              const featuredImage =
                expert?.featuredImage?.node?.localfile || "";
              const sourceUrl = expert?.featuredImage?.node?.mediaItemUrl || "";
              const title = expert?.title || "";
              const instructorRole =
                expert?.courseInstructors?.instructorRole || "";
              const content = stripHtmlTags(expert?.content ?? "");

              return (
                <SwiperSlide key={index} className="w-9/12">
                  <CourseExpert
                    featuredImage={featuredImage}
                    sourceUrl={sourceUrl}
                    title={title}
                    instructorRole={instructorRole}
                    content={content}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      <div
        className={`swiper-button-prev swiper-arrow-button rotate-180 !left-[6vw] !w-11 h-11 after:hidden !hidden
        ${currentSlide === 0 ? "lg:!hidden" : "lg:!block"}`}
        onClick={() => swiperRef.current.swiper.slidePrev()}
      />
      <div
        className={`swiper-button-next swiper-arrow-button !right-[6vw] !w-11 h-11 after:hidden text-white !z-30 ${
          currentSlide === expertsData.length - 1
            ? "!hidden"
            : "!hidden lg:!block"
        }`}
        onClick={() => swiperRef.current.swiper.slideNext()}
      />
    </section>
  );
};

export default CourseExpertList;
